// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"7cd18f31","353":"ae787e90","491":"61975dbb","851":"395f06bd"}[chunkId] + ".chunk.js";
};